<template>
  <ModalTemplate
    transitionName="bounce"
    :isModalOpen="showModal.isSuccess"
    :errorTitle="modalContents.title"
  >
    <template v-slot:contentDescription>
      <p
        v-for="(sentence, index) in sentences"
        :key="`success_modal_${index}`"
      >
        {{ sentence }}
      </p>
    </template>
  </ModalTemplate>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';

const { showModal, modalContents } = useCommonStore();

const sentences = computed((): string[] => {
  return modalContents.description.split('\n');
});
</script>

<style scoped lang="scss"></style>